<template>
    <main class="home">
        <div v-if="isAuthenticated" class="wrapper">
            <div class="home-logged__row">
                <div class="home-logged__column home-logged__column--large">
                    <h1 class="home__title">Klinika Chirurgii Ogólnej, Transplantacyjnej i Wątroby</h1>
                    <p class="home__block-text">
                        Klinika Chirurgii Ogólnej, Transplantacyjnej i Wątroby świadczy pełen zakres operacji i zabiegów
                        chirurgicznych
                        z zakresu chirurgii ogólnej i gastroenterologiczno – onkologicznej ze szczególnym uwzględnieniem
                        chirurgii i
                        radiologii interwencyjnej oraz zabiegowej endoskopii <br>u chorych na nowotwory narządów
                        przewodu pokarmowego
                        (pierwotne i przerzutowe nowotwory wątroby, nowotwory dróg żółciowych, trzustki i jelita
                        grubego).
                    </p>
                    <div class="home-logged__left">
                        <router-link to="/osrodek-referencyjny" class="btn">OŚRODEK REFERENCYJNY</router-link>
                    </div>
                </div>
                <div class="home-logged__column home-logged__column--small">
                    <img src="@/assets/svg/laptop-home.svg" class="home-logged__icon" alt="Laptop"/>
                </div>
            </div>
        </div>
        <hr v-if="isAuthenticated && userData.is_doctor">
        <div v-if="isAuthenticated && userData.is_doctor" class="wrapper">
            <div class="home-logged__row">
                <div class="home-logged__column home-logged__column--small">
                    <img src="@/assets/svg/bell.svg" class="home-logged__icon" alt="Bell"/>
                </div>
                <div class="home-logged__column home-logged__column--large">
                    <h1 class="home__title">Omówienie przypadków klinicznych</h1>
                    <p class="home__block-text">
                        Platforma służy omówieniu przypadków klinicznych z chirurgicznym ośrodkiem referencyjnym. Każdy
                        przypadek raka
                        jelita grubego można zgłaszać za pomocą szczegółowego formularza, który oprócz opisu daje
                        możliwość załączania
                        wyników badań, w tym również badań MRI.
                    </p>
                    <p class="home__block-text">
                        Edukator, po zapoznaniu się z treścią zgłoszenia, omówi czy zgłoszony przypadek kwalifikuje się
                        do leczenia
                        chirurgicznego. Im wcześniej zgłoszony przypadek tym większa szansa na leczenie operacyjne.
                    </p>
                    <p class="home__block-text">
                        Po wysłaniu zgłoszeniu istnieje możliwość korespondencji z ekspertem w celu dalszej edukacji.
                    </p>
                    <div class="home-logged__left">
                        <router-link to="/zglos-przypadek" class="btn">ZGŁOŚ PRZYPADEK</router-link>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="!isAuthenticated" class="wrapper">
            <h1 class="home__title">Platforma edukacyjna dla lekarzy onkologów</h1>
            <p class="home__block-text">
                Projekt stanowi platformę edukacyjną dla lekarzy onkologów zajmujących się leczeniem pacjentów
                z uogólnionym rakiem jelita grubego. Umożliwia edukację lekarzy w zakresie wyboru terapii
                uogólnionego raka jelita grubego poprzez możliwość konsultacji przypadków klinicznych z
                chirurgicznym ośrodkiem referencyjnym.
            </p>
            <p class="home__block-text">
                Projekt został objęty opieką merytoryczną dwóch specjalistów z zakresu onkologii i chirurgii.
            </p>
            <div class="home__center">
                <router-link to="/rejestracja" class="btn">Dołącz do projektu</router-link>
            </div>
        </div>
    </main>
</template>

<script>
import {mapGetters} from "vuex";

export default {
    name: "Homepage",
    computed: mapGetters({
        isAuthenticated: "isAuthenticated",
        userData: "getUserData",
    })
};
</script>

<style lang="scss">
.home {
    padding: 50px 0;
    flex: 1;

    &__title {
        font-size: 20px;
    }

    &__block-text {
        font-size: 16px;
        line-height: 25px;
    }

    &__center {
        margin: 20px;
        text-align: center;
    }
}

.home-logged {
    &__left {
        text-align: left;
    }

    &__row {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        width: 100%;
        margin-bottom: 80px;
    }

    &__column {
        &--large {
            flex: 2;
        }

        &--small {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }

    &__icon {
        height: 218px;
        width: 228px;
        vertical-align: middle;
    }
}
</style>
